import { Button } from 'reactstrap';

const DeletingToolbar = ({ onCancel, onConfirm, name, fullText = null }) => {
  return (
    <div className="d-flex justify-content-end align-items-center">
      <span>
        {fullText || (
          <>
            Are you sure you want to delete <b>{name}</b>?
          </>
        )}
      </span>
      <Button onClick={onCancel} className="ml-2" outline size="sm">
        Cancel
      </Button>
      <Button onClick={onConfirm} className="ml-2" color="primary" size="sm">
        Confirm
      </Button>
    </div>
  );
};

export default DeletingToolbar;
